import React, { useState, useEffect } from "react";
import Header from "../../../../Global/Header/Header";
import Footer from "../../../../Global/Footer/Footer";
import { createUrl, get, post } from "../../../../network/AxiosInterceptor";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../../components/ui/use-toast";
import { Toaster } from "../../../../components/ui/toaster";
import { Input } from "../../../../components/ui/input";

const CreateReview = (props) => {

    const navigate = useNavigate();

    const [reviewId, setReviewId] = useState("");
    const [reviewTrip, setReviewTrip] = useState("");
    const [reviewTripMonth, setReviewTripMonth] = useState("");
    const [reviewTitle, setReviewTitle] = useState("");
    const [reviewContent, setReviewContent] = useState("");
    const [reviewExplorer, setReviewExplorer] = useState("");
    const [reviewExplorerPic, setReviewExplorerPic] = useState("");
    const [reviewStatus, setReviewStatus] = useState("live");
    const { toast } = useToast();

    const showToastOnSaveSuccess = (message) => {
        toast({
            title: "Exploro",
            description: message,
            variant: "default",
        });
    };

    const showToastOnSaveFailed = (message) => {
        toast({
            title: "Exploro",
            description: message,
            variant: "destructive",
        });
    };

    useEffect(() => {
        toast({}).dismiss();
        window.scrollTo(0, 0);
    },[])

    useEffect(() => {
        const parts = window.location.pathname.split('/');
        const id = parts[parts.length - 1];
        if(id=="createReview")return;
        post(createUrl("/api/reviews/filterReviews"), {
            params: {
                _id: id
            }
        }).then((response) => {
            if (response?.data?.length > 0) {
                const review = response?.data[0];
                setReviewTrip(review?.reviewTrip);
                setReviewTripMonth(review?.reviewTripMonth);
                setReviewTitle(review?.reviewTitle);
                setReviewContent(review?.reviewContent);
                setReviewExplorer(review?.reviewExplorer);
                setReviewExplorerPic(review?.reviewExplorerPic);
                setReviewStatus(review?.reviewStatus);
                setReviewId(review?._id);
            } else {
                navigate('/admin/reviews')
            }

        }).catch(err => {
            console.log(err)
        })
    }, [])

    const onReviewTripChange = (e) => {
        setReviewTrip(e.target.value);
    }

    const onReviewTripMonthChange = (e) => {
        setReviewTripMonth(e.target.value);
    }

    const onReviewTitleChange = (e) => {
        setReviewTitle(e.target.value);
    }

    const onReviewContentChange = (e) => {
        setReviewContent(e.target.value);
    }

    const onReviewExplorerChange = (e) => {
        setReviewExplorer(e.target.value);
    }

    const onReviewExplorerPicChange = (e) => {
        setReviewExplorerPic(e.target.value);
    }

    const onReviewStatusChange = (e) => {
        if (!e.target.checked) {
            setReviewStatus('pause');
        } else {
            setReviewStatus('live')
        }
    }

    const saveHandler = (e) => {
        if (reviewId) {
            post(createUrl("/api/reviews/createReview"), {
                id: reviewId,
                reviewTrip: reviewTrip,
                reviewTripMonth: reviewTripMonth,
                reviewTitle: reviewTitle,
                reviewContent: reviewContent,
                reviewExplorer: reviewExplorer,
                reviewExplorerPic: reviewExplorerPic,
                reviewStatus: reviewStatus
            }).then((response) => {
                showToastOnSaveSuccess("Review Updated Successfully");
                const currUrl= window.location.pathname.split('/').slice(0,-2).join('/');
                setTimeout(() => {
                    navigate(`${currUrl}/reviews`);
                },2000)
            }).catch(err => {
                showToastOnSaveFailed("Error in Review updation");
            })
        } else {
            post(createUrl("/api/reviews/createReview"), {
                reviewTrip: reviewTrip,
                reviewTripMonth: reviewTripMonth,
                reviewTitle: reviewTitle,
                reviewContent: reviewContent,
                reviewExplorer: reviewExplorer,
                reviewExplorerPic: reviewExplorerPic,
                reviewStatus: reviewStatus
            }).then((response) => {
                showToastOnSaveSuccess("Review Created Successfully");
                const currUrl= window.location.pathname.split('/').slice(0,-2).join('/');
                setTimeout(() => {
                    navigate(`${currUrl}/reviews`);
                },2000)
            }).catch(err => {
                showToastOnSaveFailed("Error in Review Creation");
            })
        }

    }

    return (
        <div>
            <Header />
            <div className="w-[100vw] mb-[8vw] lg:mb-[4vw] lg:mt-[2vw] flex flex-col items-center space-y-[5vw] lg:space-y-[3vw] text-[2vw] lg:text-[1vw]">
                <p className="text-[5vw] lg:text-[3vw] font-bold">Create a Review</p>
                <input className="w-[80%] h-[5vw] lg:h-[3vw] px-[2vw] lg:px-[1vw] border-[1px] border-[rgba(0,0,0,0.3)] rounded-[5px] lg:rounded-[10px]" type="text" placeholder="Enter Review Trip" defaultValue={reviewTrip} onChange={onReviewTripChange} />
                <input className="w-[80%] h-[5vw] lg:h-[3vw] px-[2vw] lg:px-[1vw] border-[1px] border-[rgba(0,0,0,0.3)] rounded-[5px] lg:rounded-[10px]" type="text" placeholder="Enter Review Trip Month" defaultValue={reviewTripMonth} onChange={onReviewTripMonthChange} />
                <input className="w-[80%] h-[5vw] lg:h-[3vw] px-[2vw] lg:px-[1vw] border-[1px] border-[rgba(0,0,0,0.3)] rounded-[5px] lg:rounded-[10px]" type="text" placeholder="Enter Review Trip Title" defaultValue={reviewTitle} onChange={onReviewTitleChange} />
                <input className="w-[80%] h-[5vw] lg:h-[3vw] px-[2vw] lg:px-[1vw] border-[1px] border-[rgba(0,0,0,0.3)] rounded-[5px] lg:rounded-[10px]" type="text" placeholder="Enter Review Trip Content" defaultValue={reviewContent} onChange={onReviewContentChange} />
                <input className="w-[80%] h-[5vw] lg:h-[3vw] px-[2vw] lg:px-[1vw] border-[1px] border-[rgba(0,0,0,0.3)] rounded-[5px] lg:rounded-[10px]" type="text" placeholder="Enter Review Trip Explorer" defaultValue={reviewExplorer} onChange={onReviewExplorerChange} />
                <input className="w-[80%] h-[5vw] lg:h-[3vw] px-[2vw] lg:px-[1vw] border-[1px] border-[rgba(0,0,0,0.3)] rounded-[5px] lg:rounded-[10px]" type="text" placeholder="Enter Review Trip Explorer Pic" defaultValue={reviewExplorerPic} onChange={onReviewExplorerPicChange} />
                {/* <input className="w-[80%] h-[5vw] lg:h-[3vw] px-[2vw] lg:px-[1vw] border-[1px] border-[rgba(0,0,0,0.3)] rounded-[5px] lg:rounded-[10px]" type="text" placeholder="Enter Review Trip Status" /> */}
                <label className="flex flex-row gap-x-[3vw] lg:gap-x-[1vw] mr-[auto] ml-[10%] font-bold text-[3.5vw] lg:text-[2vw] items-center">
                    <input
                        className="lg:w-[1.3vw] lg:h-[1.3vw] w-[3vw] h-[3vw] cursor-pointer"
                        type="checkbox"
                        name="live"
                        checked={reviewStatus === 'live' ? true : false}
                        onChange={onReviewStatusChange}
                    />
                    Live
                </label>
                <button className="w-[15vw] h-[5vw] text-[2.5vw] ml-[auto] mr-[10%] lg:w-[10vw] lg:h-[3vw] bg-green-400 lg:text-[1.3vw] rounded-[5px] lg:rounded-[10px]" onClick={saveHandler}>Save</button>
            </div>
            <Footer />
            <Toaster />
        </div>
    )
};

export default CreateReview;